// /frontend/src/utils/mediaValidator.js
//
// validateMedia(file, { format }) → { ok, error?, meta }
// Uses the raw File object (width/height/duration) to enforce Story/Reel rules.

export async function validateMedia(file, { format }) {
  const sizeMB = +(file.size / (1024 * 1024)).toFixed(1);
  const maxSizeMB = 4000;

  const meta = await new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const v = document.createElement('video');
    v.preload = 'metadata';
    v.onloadedmetadata = () => {
      resolve({
        width: v.videoWidth,
        height: v.videoHeight,
        duration: v.duration,
      });
      URL.revokeObjectURL(url);
    };
    v.onerror = reject;
    v.src = url;
  });

  const { width, height, duration } = meta;
  const isLandscape = width > height;

  if (sizeMB > maxSizeMB)
    return { ok: false, error: `File is too large (${sizeMB} MB).` };

  if (format === 'story' || format === 'reel') {
    if (isLandscape)  return { ok:false, error:'Stories/Reels must be vertical (9×16).' };
    if (height < 960) return { ok:false, error:'Vertical resolution must be ≥ 960 px.' };
    if (duration < 3 || duration > 90)
      return { ok:false, error:'Video length must be 3–90 s.' };
    if (format === 'story' && duration > 60)
      return { ok:false, error:'Story videos can’t exceed 60 s.' };
  }
  return { ok:true };
}
